const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/teams/team/$teamId/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { FullSizeSpinner } from '@/components/ui/FullSizeSpinner';
import { getTeamQueryOptions } from '@/lib/queries/teams/useGetTeamQuery';
import i18n from '@/lib/translations/i18n';
import { compactBooleanFilterSchema, compactPicklistFilterSchema } from '@/lib/zod-schemas/common/compactFilterSchemas';
export const teamSearchSchema = z.object({
  resourceStatus: z.enum(['ACTIVE', 'DEACTIVATED', 'ALL']).optional(),
  roleId: compactPicklistFilterSchema,
  skillId: compactPicklistFilterSchema,
  locationId: compactPicklistFilterSchema,
  showDeactivatedMembers: compactBooleanFilterSchema,
  showPastMemberships: compactBooleanFilterSchema,
  showFutureMemberships: compactBooleanFilterSchema
}) satisfies z.ZodType<{
  resourceStatus?: ResourceFilterStatus;
  roleId?: string;
  skillId?: string;
  locationId?: string;
  showDeactivatedMembers?: string;
  showPastMemberships?: string;
  showFutureMemberships?: string;
}>;
export const Route = createFileRoute('/(app)/org/$org/teams/team/$teamId')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(teamSearchSchema),
  loader: async ({
    params: {
      teamId
    },
    context: {
      queryClient
    }
  }): Promise<LoaderData> => {
    if (!teamId) {
      return {
        crumb: i18n.t('team', {
          ns: 'teams'
        })
      };
    }
    try {
      const teamData = await queryClient.ensureQueryData(getTeamQueryOptions({
        teamId: Number(teamId)
      }));
      const teamName = teamData?.team?.name || i18n.t('team', {
        ns: 'teams'
      });
      return {
        crumb: teamName,
        dynamicTitle: teamName
      };
    } catch (_error) {
      // Error loading team data
      return {
        crumb: i18n.t('team', {
          ns: 'teams'
        })
      };
    }
  },
  pendingComponent: FullSizeSpinner
});